import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env and fill it in.',
  );
}

/**
 * Single Supabase client for the whole app.
 *
 * Auth is fully delegated to Supabase (SRS §4): the app never reads, hashes,
 * stores or transmits raw credentials itself, and never mints its own session
 * tokens. Session persistence and refresh are handled by supabase-js.
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

/**
 * Current access token, or null when signed out.
 * Used only for the `Authorization` header — never as a URL query parameter.
 * SSE auth uses a short-lived, per-request token minted by the backend instead.
 */
export async function getAccessToken(): Promise<string | null> {
  const { data, error } = await supabase.auth.getSession();
  if (error) return null;
  return data.session?.access_token ?? null;
}
